export default class Utils{

	static validateEmail(value){

	    if(typeof value != 'string')
	        return false;

	    return value.match(/^[0-9a-zA-Z._-]+@[0-9a-zA-Z-]+\.[a-z]{2,}$/) != null;

	}

	static validateName(value){

	    // The name must be a string
	    if(typeof value != 'string')
	        return false;

	    return value.length > 0 && value.match(/[0-9!@#$%^&*()=+\/\\]/) == null;

	}

	static validateNumber(value){

	    // The name must be a string
	    if(typeof value != 'string')
	        return false;

	    return /^(?=.*\d)[\d ]+$/.test(value);

	}

	static validateNotEmpty(value){

	    if(typeof value != 'string')
	        return false;

	    return value.length > 0;

	}

	static validatePhone(value){

	    if(typeof value != 'string')
	        return false;

	    return value.match(/^(\(|[0-9])\s?[0-9]+\)?[0-9\s-]+[0-9]$/) != null && value.length <= 15;

	}

	static validateZipCode(value){

	    if(typeof value != 'string')
	        return false;

	    var regex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
	    return regex.test(value);

	}
}

